import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const territoryMappingRoutes = [
	{
		key: "region-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/territory-mapping/region`,
		component: React.lazy(() => import("views/app-views/territory-mapping/pages/RegionList")),
	},
	{
		key: "region-add",
		exact: true,
		path: `${APP_PREFIX_PATH}/territory-mapping/region/add`,
		component: React.lazy(() => import("views/app-views/territory-mapping/pages/RegionAdd")),
	},
	{
		key: "region-view",
		exact: true,
		path: `${APP_PREFIX_PATH}/territory-mapping/region/view/:id`,
		component: React.lazy(() => import("views/app-views/territory-mapping/pages/TerritoryView")),
	},
	{
		key: "region-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/territory-mapping/region/edit/:id`,
		component: React.lazy(() => import("views/app-views/territory-mapping/pages/RegionEdit")),
	},
];
